// Shared logic between the global router guard and App.vue's initial load
// check, so both agree on exactly which routes stay reachable when an
// academy's BJJLINK platform subscription has gone inactive.
export const EXEMPT_ROUTE_NAMES = [
  "root",
  "inapp",
  "login",
  "logout",
  "applogin",
  "triallogin",
  "notadmin",
  "notactive",
  "noacademy",
  "selectacademy",
  "pickacademy",
  "home",
  "upgrade-plan-adminplus",
  "academysetup",
  "manageacademies",
  "notfound",
];

export function resolveBlockedRedirect(routeName, academyAdminStatus) {
  if (EXEMPT_ROUTE_NAMES.includes(routeName)) return null;
  if (!academyAdminStatus) return null; // not loaded yet - fail open
  if (academyAdminStatus.isInternalAdmin) return null;
  if (academyAdminStatus.isActive === false) return { name: "home" };
  return null;
}
